import { paletteColors } from './palette'
import { Components } from '@mui/material/styles/components'
import { Theme } from '@mui/material/styles/createTheme'
import { palette } from './palette'

type components = Components<Omit<Theme, 'components'>>

export const components: components = {
  MuiButton: {
    styleOverrides: {
      outlined: {
        padding: '8px 8px',
        borderRadius: 8,
        fontSize: 12,
        lineHeight: 1.57,
        fontFamily: 'Montserrat, sans-serif',
        textTransform: 'none',
        border: '1px solid #ADB5BD',
        color: '#4B5563',
        height: 40,
        backgroundColor: 'transparent',
        fontWeight: 600,
        '&:hover': {
          backgroundColor: 'transparent',
        },
      },
      contained: {
        padding: '8px 8px',
        fontSize: 14,
        lineHeight: 1.57,
        fontFamily: 'Inter, sans-serif',
        textTransform: 'none',
        border: 'none',
        borderRadius: 8,
        color: paletteColors.white,
        height: 40,
        minWidth: 90,
        backgroundColor: palette.primary?.main,
        '&:hover': {
          boxShadow: 'none',
          backgroundColor: palette.primary?.main,
        },
        boxShadow: 'none',
        '&:disabled': {
          backgroundColor: palette.primary?.main,
          opacity: 0.4,
          color: 'white',
        },
      },
    },
  },
  MuiSelect: {
    styleOverrides: {
      standard: { color: paletteColors.greyTurquoise },
      icon: {
        color: paletteColors.turquoise,
      },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      root: {
        color: paletteColors.dark,
        borderBottom: `1px solid ${paletteColors.iconLightGrey}`,
      },
      head: {
        color: paletteColors.dark,
      },
      body: {
        color: paletteColors.dark,
      },
      stickyHeader: {
        backgroundColor: paletteColors.nearWhite,
      },
    },
  },
  MuiTableContainer: {
    styleOverrides: {
      root: {
        '&::-webkit-scrollbar-thumb': {
          background: paletteColors.turquoise,
        },
      },
    },
  },
  MuiTablePagination: {
    styleOverrides: {
      root: {
        color: paletteColors.dark,
      },
      actions: {
        color: paletteColors.turquoise,
      },
    },
  },
  MuiIconButton: {
    styleOverrides: {
      root: {
        '&:disabled': {
          color: `${paletteColors.greySoft} !important`,
        },
      },
    },
  },
  MuiInputBase: {
    styleOverrides: {
      root: {
        background: paletteColors.lightGrey,
        color: paletteColors.turquoise,
        '&:focused': {
          color: paletteColors.green,
        },
      },
      input: {
        color: paletteColors.greyTurquoise,
        backgroundColor: paletteColors.greySoft,
        border: `1px solid ${paletteColors.lightGrey}`,
        borderRadius: 8,
        paddingLeft: 8,
        '&::placeholder': {
          color: paletteColors.turquoise,
        },
        '&:focus': {
          backgroundColor: `${paletteColors.greySoft} !important`,
        },
      },
    },
  },
  MuiFormLabel: {
    styleOverrides: {
      root: {
        color: paletteColors.turquoise,
        '&.Mui-focused': {
          color: paletteColors.green,
        },
      },
    },
  },
  MuiCheckbox: {
    styleOverrides: {
      root: {
        padding: 0,
        border: `1px solid ${paletteColors.lightGrey}`,
        '&:hover': {
          color: paletteColors.violet,
        },
        '&$checked': {
          color: paletteColors.green,
        },
      },
      colorSecondary: {
        '&$checked': {
          color: `${paletteColors.violet} !important`,
        },
      },
    },
  },
  MuiInput: {
    styleOverrides: {
      root: {
        border: `1px solid ${paletteColors.lightGrey}`,
        '&:hover': {
          border: `1px solid ${paletteColors.grey} !important`,
        },
      },
      underline: {
        '&::before': {
          borderBottom: `none`,
          borderBottomStyle: `none !important`,
        },
        '&::after': {
          borderBottom: 'none',
        },
        '&:hover:not(.Mui-disabled):before': {
          borderBottom: `none`,
        },
      },
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      shrink: {
        transform: 'translate(0, 1.5px) scale(1)',
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        backgroundColor: paletteColors.greySoft,
      },
    },
  },
  MuiDialog: {
    styleOverrides: {
      paper: {
        background: paletteColors.white,
      },
    },
  },
  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        backgroundColor: paletteColors.violet,
        fontSize: 14,
        maxWidth: 'max-content',
      },
    },
  },
  MuiAutocomplete: {
    styleOverrides: {
      root: {
        '& .MuiOutlinedInput-notchedOutline': {
          border: 'none',
        },
        '& .MuiAutocomplete-input': {
          padding: '12px 4px',
          border: '1px solid #E5E7EB !important',

          '&::placeholder': {
            color: paletteColors.darkTurquoise,
          },
          '&:hover': {
            border: `1px solid ${paletteColors.grey} !important`,
          },
        },
      },
    },
  },
}
